import Vue from 'vue'
import Router from 'vue-router'
import VueSession from 'vue-session'
import store from './store.js'

import Login from './components/Login.vue'
import Projects from './components/Projects.vue'
import ProjectView from './components/ProjectView.vue'
import Submissions from './components/Submissions.vue'
import Profile from './components/Profile.vue'
import PurchaseHistory from './components/PurchaseHistory.vue'
import LinkedInAuth from './components/LinkedInAuth.vue'
import AutoLogin from './components/AutoLogin.vue'

Vue.use(Router)
var options = {
  persist: true
}

Vue.use(VueSession, options)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'projects',
      component: Projects,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:name/view',
      name: 'project_view',
      component: ProjectView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/submissions',
      name: 'submissions',
      component: Submissions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/payments',
      name: 'purchase_history',
      component: PurchaseHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/auto_login',
      name: 'auto_login',
      component: AutoLogin
    },
    {
      path: '/linkedin/callback',
      name: 'linkedin_callback',
      component: LinkedInAuth
    }
  ]
})

export default router

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

